<template>
  <div class="grid-view tab-bill-payment">
    <query-bill-payment
      ref="queryBillPayment"
      :is-append-query="isAppendQuery"
      identify="queryBillPayment"
      view-source="billPaymentList"
      :show-real-clearing-state="searchConditions.showRealClearingState"
      :state="searchConditionsState"
      :paid-off="searchConditionsPaidOff"
      :is-check-charge="searchConditions.isCheckCharge"
      :show-controlled-charge="searchConditions.showControlledCharge"
      :show-fba="false"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :clearing-states="searchConditionsClearingStates"
      :show-wht="showWht"
      config-module="508"
      :is-bpm="true"
      grid-config-module="190801"
      @rowDoubleClicked="rowDoubleClicked"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <el-button type="primary" @click="toDetail(false, null)">{{ $t('Payment.viewDetails_SR') }}</el-button>
        <el-button v-show="[0, 1, 2, 3, 4].includes(applicationStatus)" type="primary" @click="toCollectInvoice">{{ $t('Payment.collectInvoice') }}</el-button>
        <!-- <el-button type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
        <el-dropdown
          split-button
          type="primary"
          style="margin: 0 5px;"
          @click="toPrint($t('Payment.print'))"
          @command="toPrint"
        >
          {{ $t('Payment.print') }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-show="[0, 1, 2, 3, 4].includes(applicationStatus)" type="primary" @click="toCreatePayment">{{ $t('Payment.newPaymentRequest') }}</el-button>
        <el-button v-show="[1].includes(applicationStatus)" type="primary" @click="doCommit">{{ $t('Payment.submit') }}</el-button>
        <el-button v-show="[1, 4].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuthBpm_btnBillDelete'])" type="danger" @click="doDelete">{{ $t('Payment.delete') }}</el-button>
        <!--        <el-button v-show="[0, 3].includes(applicationStatus)" type="danger" @click="doCancel">{{ $t('CargoMsg.Cargo_Invalid') }}</el-button>-->
        <el-button v-show="paymentChange && applicationStatus === 2" no="12" type="primary" @click="toBatchChangeTime">{{ $t('Payment.changePaymentRequest') }}</el-button>
      </div>
      <template v-slot:other>
        <el-form :inline="true" label-width="60px" label-position="left" style="margin-right: 15px;">
          <el-form-item :label="$t('Billing.billingJob_billPaymentDate')" class="el-form-item-search">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateStart"
                    type="date"
                    style="margin-right: 0px;"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  /></el-form-item>
              </el-col>
              <el-col :span="2"><span>{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateEnd"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-checkbox v-model="allowTwoYearOutside">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </template>
    </query-bill-payment>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      @selectedTemplate="updatePrintField"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="billPaymentList"
      location="location"
      @reloadData="reloadData"
    />
    <!-- 批量修改支付弹窗 -->
    <el-dialog
      v-if="changePaymentDialog.visible"
      v-el-drag-dialog
      :visible.sync="changePaymentDialog.visible"
      :title="$t('CargoMsg.Cargo_ChangePayment')"
      width="450px"
      height="400px"
      class="changePaymentRequest"
      :close-on-click-modal="false"
    >
      <template>
        <div>
          <div class="dialog-body" style="padding-left: 10px; padding-top: 20px; padding-bottom: 26px">
            <div>
              <span class="name">{{ $t('CargoMsg.Cargo_PaymentTimeLimit') }}</span>
              <el-date-picker v-model="changePaymentDialog.deadLine" :clearable="false" :editable="false" type="date" />
            </div>
            <div style="margin-top: 7px; display: flex">
              <span class="name" style="width: 25px; margin-left:23px">{{ $t('CargoMsg.Cargo_Remarks') }}</span>
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="changePaymentDialog.remark"
                  type="textarea"
                  :rows="5"
                  style="width: 220px"
                />
                <span style="margin-top: 7px">{{ $t('CargoMsg.Cargo_BillPaymentRemarkTip') }}</span>
              </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer" style="justify-content: right">
            <el-button type="primary" size="small" @click="changePaymentConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
            <el-button size="small" @click="changePaymentDialog.visible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import makeInvoiceStepOneDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepOneDialog'
import queryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPayment'
import moment from 'moment'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import {
  batchDelBillPayment,
  batchCancelBillPaymentFunc, changePaymentList, uploadHasPrint
} from '@/api/clearing/billPayment'
import { cache, cacheName } from '@/utils/cacheManager'
import billPaymentCreatorDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentCreatorDialog'
import { validateRoleByUserIdAndRoleName } from '@/api/role'
import GlobalDialog from '@/utils/GlobalDialog'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { workflowActionBatch } from '@/api/workflow'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import {
  APPLICATION_DIMENSION_BILL_PAYMENT,
  APPLICATION_DIMENSION_JOB_CHARGE,
  VIEW_SOURCE_BILL_PAYMENT_APPLY
} from '@/class/cargo/model/parameters/WorkflowConstants'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import DateUtils from '@/utils/dateUtils'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabBillPaymentBpm',
  components: {
    CargoDialog,
    cargoTemplateSelectorDialog,
    billPaymentDialog,
    makeInvoiceStepOneDialog,
    queryBillPayment, // 付款申请查询列表
    makeInvoiceDialog, // 开票弹出框
    billPaymentCreatorDialog, // 创建付款申请弹窗
    batchSubmitOrApproveDialog
  },
  props: {
    applicationStatus: { type: Number, default: 0 }, // bpm付款申请状态: 0=所有;1=未提交;2=审批中;3=审批通过;4=未付清;
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      openSapConfig: false,
      // 用于批量修改付款申请时间
      paymentChange: this.$checkPermission(['button_ACPayAuthBpm_modifyPayment']),
      loading: false,
      searchConditions: {
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: '',
        showControlledCharge: false,
        isCheckCharge: true,
        showRealClearingState: true
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      isDirectPayment: false,
      allowTwoYearOutside: false,
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      billPaymentDialog: { // 付款申请弹窗【查看明细】
        visible: false,
        title: '',
        billPaymentUuid: ''
      },
      makeInvoiceDialog: { // 收票弹窗页
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 5 // 开票方式: 5=付款申请
      },
      billPaymentCreatorDialog: null,
      // 修改付款申请弹窗
      changePaymentDialog: {
        visible: false,
        deadLine: '',
        rowDataList: [],
        remark: ''
      },
      canSendWeaver: false,
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      viewSource: VIEW_SOURCE_BILL_PAYMENT_APPLY.code,
      location: LOG_BILL_PAYMENT.code
    }
  },
  computed: {
    searchConditionsState() {
      switch (this.applicationStatus) {
        case 0: return [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code, ClearingConstants.BILL_PAYMENT_APPROVING_BPM.code, ClearingConstants.BILL_PAYMENT_APPROVED_BPM.code]
        case 1: return [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code]
        case 2: return [ClearingConstants.BILL_PAYMENT_APPROVING_BPM.code]
        case 3: return [ClearingConstants.BILL_PAYMENT_APPROVED_BPM.code]
        // 不用传【已作废】，传了也查询不出来，因为作废的单子会将费用解绑
        case 4: return [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code, ClearingConstants.BILL_PAYMENT_APPROVING_BPM.code, ClearingConstants.BILL_PAYMENT_APPROVED_BPM.code]
        default: return []
      }
    },
    searchConditionsClearingStates() {
      if (this.applicationStatus === 4) {
        return [0, 1]
      } else {
        return []
      }
    },
    searchConditionsPaidOff() {
      if (this.applicationStatus === 4) {
        return 0
      } else {
        return -1
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Billing.billingJob_unlockBillPaymentDateQuery'), this.$t('Message.Prompt'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
    let isDirectPayment = false
    const roleMap = await validateRoleByUserIdAndRoleName(['上海空运付款', '付款申请直达']).then(res => {
      return res.data
    })
    if (roleMap) {
      if (roleMap.hasOwnProperty('付款申请直达') && roleMap['付款申请直达']) {
        isDirectPayment = true
      }
    }
    this.isDirectPayment = isDirectPayment
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.billPaymentCreatorDialog) {
      this.billPaymentCreatorDialog.instance.destroySelf()
    }
    if (this.billPaymentDialog.dialog) {
      this.billPaymentDialog.dialog.instance.destroySelf()
    }
  },
  methods: {
    // 批量修改时间
    changePaymentConfirm() {
      // 判断时间参数是否为空
      if (!this.changePaymentDialog.deadLine) {
        this.$message({
          message: this.$t('CargoMsg.Cargo_NotEmptyChangePaymentTime'),
          type: 'warning'
        })
        return
      }
      // 下发时间参数
      // 获取需要批量修改任务单号
      const uuidList = this.changePaymentDialog.rowDataList.map(item => item.uuid)
      // 下发请求
      const param = { 'billPaymentKeys': uuidList, 'deadLine': this.changePaymentDialog.deadLine, 'remark': this.changePaymentDialog.remark }
      this.loading = getLoading()
      changePaymentList(param).then(res => {
        if (res.code === '0') {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message({
            type: 'success',
            message: this.$t('CargoMsg.Cargo_batchChangePaymentSuccess')
          })
        } else {
          this.$message({
            type: 'error',
            message: this.$t('CargoMsg.Cargo_batchChangePaymentFailed')
          })
        }
      }).catch(e => {
        this.$message({
          type: 'error',
          message: this.$t('CargoMsg.Cargo_batchChangePaymentFailed')
        })
      }).finally(() => {
        this.changePaymentDialog.visible = false
        this.loading.close()
      })
    },
    // 打开批量修改付款弹窗，初始化参数
    toBatchChangeTime() {
      this.changePaymentDialog.rowDataList = this.$refs.queryBillPayment.getSelections()
      if (this.changePaymentDialog.rowDataList == null || this.changePaymentDialog.rowDataList.length === 0) {
        this.$message({
          message: this.$t('CargoMsg.Cargo_PleaseSelectTheRecord'),
          type: 'warning'
        })
        return
      }
      // 打开弹窗
      // CARGO-39655 只有选中单条数据时，带入备注信息
      this.changePaymentDialog.remark = ''
      if (this.changePaymentDialog.rowDataList.length === 1) {
        this.changePaymentDialog.remark = this.changePaymentDialog.rowDataList[0].remark
      }
      this.changePaymentDialog.visible = true
      this.changePaymentDialog.deadLine = DateUtils.formatStandardDate(new Date())
    },

    // 是否可选择两年以外的时间点
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 查看详情
    toDetail(doubleClick = false, row = null) {
      let billPayment = null
      if (doubleClick) { // 双击查看
        billPayment = row
      } else {
        const chooseRows = this.$refs.queryBillPayment.getSelections()
        if (chooseRows && chooseRows.length > 0) {
          billPayment = chooseRows[0]
        }
      }
      if (!billPayment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      if (billPayment.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(billPayment.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      this.billPaymentDialog.billPaymentUuid = billPayment.uuid
      this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      const propsData = {
        visible: true,
        title: this.billPaymentDialog.title,
        billPaymentUuid: this.billPaymentDialog.billPaymentUuid,
        isDirectPayment: this.isDirectPayment,
        openSapConfig: this.openSapConfig,
        toExoSystemYGSH: String(cache.config.get('ToExoSystem')) === 'YGSH',
        step: 'step2',
        mode: 'edit',
        showWht: this.showWht,
        viewSource: 'billPaymentNew',
        location: this.location
      }
      this.billPaymentDialog.dialog = new GlobalDialog(billPaymentDialog, { propsData })
      const { instance } = this.billPaymentDialog.dialog
      console.log('instance', instance)
      instance.$on('cancel', () => { this.billPaymentDialog.dialog.instance.visible = false })
      instance.$on('reloadData', this.reloadData)
    },
    // 收票按钮触发事件
    toCollectInvoice() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const queryOfficeId = this.$refs.queryBillPayment.queryOfficeId
      if (queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      let message = ''
      // 选中数据中是否存在可开票账单
      let isC = false
      for (const bp of chooseRows) {
        if (!bp.notInvoiceByCharge) {
          if (message) {
            message += ','
          }
          message = message + bp.billPaymentNo
        } else {
          isC = true
        }
      }
      if (message && isC) {
        this.$message.warning('包含已开票的费用，请重新选择！付款申请单号：' + message)
        return
      } else if (message && !isC) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      this.makeInvoiceDialog.isAr = false
      this.makeInvoiceDialog.isHedge = false
      this.makeInvoiceDialog.isSkipInvoiceFrom = false
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      this.makeInvoiceDialog.keys = keys
      this.makeInvoiceDialog.step = 'step1'
      this.$refs.invoice.makeInvoice({ ...this.makeInvoiceDialog })
    },
    // 创建付款申请
    toCreatePayment() {
      if (!this.billPaymentCreatorDialog) {
        const propsData = { viewSource: 'billPaymentNew', location: this.location }
        this.billPaymentCreatorDialog = new GlobalDialog(billPaymentCreatorDialog, { propsData })
        const { instance } = this.billPaymentCreatorDialog
        console.log('instance', instance)
        instance.createBillPayment({ step: 'step1', title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees') })
        instance.$on('reloadData', this.reloadData)
      } else {
        this.billPaymentCreatorDialog.instance.visible = true
      }
    },
    // 打印按钮触发事件
    toPrint(command) {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      const params = {}
      const multiplePrint = chooseRows.length > 1 && command === this.$t('Clearing.PrintByPaymentRequestNumber') // 是否按照多个打印
      if (chooseRows.length === 1 || multiplePrint) {
        params.BILLPAYMENT_UUID = chooseRows[0].uuid
        params.BILL_PAYMENT_UUID = chooseRows[0].uuid
        params.printSource = DocumentConstants.BATCH_PRINT_FKSQ.code
        if (multiplePrint) {
          params.multiplePrint = true
          params.multipleBillPaymentUuid = keys
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILL_PAYMENT_UUID_LIST = keys
        params.printSource = DocumentConstants.BATCH_PRINT_FKSQ.code
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.visible = true
      }
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      } else {
        Object.assign(keys, this.templateSelectorDialog.data.BILL_PAYMENT_UUID_LIST)
      }
      this.loading = getLoading()
      uploadHasPrint(keys)
        .then(res => {
          if (res.ok && res.data) {
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }
        }).catch(() => { this.loading.close() }).finally(() => { this.loading.close() })
    },
    // 提交按钮触发事件
    doCommit() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
        return
      }
      const params = []
      const payList = []
      for (const billPayment of chooseRows) {
        payList.push(billPayment.uuid)
        const param = {
          documentConfigId: 1,
          docId: billPayment.uuid,
          docNo: billPayment.billPaymentNo,
          actionType: 7000,
          officeId: billPayment.branchId,
          applicationDimension: APPLICATION_DIMENSION_BILL_PAYMENT.code
        }
        params.push(param)
      }
      if (params.length > 0) {
        this.loading = getLoading()
        this.doWorkflowActionBatch(params).finally(() => {
          this.loading.close()
        })
      }
    },
    async doWorkflowActionBatch(params) {
      await workflowActionBatch(params).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
        } else {
          this.batchSubmitOrApproveDialog.visible = true
          this.batchSubmitOrApproveDialog.rowData = res.data
        }
        this.$refs.queryBillPayment.toQueryBillPaymentList()
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 删除按钮触发事件
    doDelete() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATD'))
        return
      }
      const list = []
      for (const billPayment of chooseRows) {
        // CARGO-33323 2.1新增”付款申请（新版）“页面
        if (billPayment.state === ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code && billPayment.realClearingState === 0) {
          list.push(billPayment)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('Message.BillPaymentDeleteTips'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_STDTPA'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const mapBillPayment = []
        for (const billPayment of list) {
          if (billPayment.uuid && billPayment.version) {
            const map = {
              uuid: billPayment.uuid,
              version: billPayment.version
            }
            if (mapBillPayment.indexOf(map) < 0) {
              mapBillPayment.push(map)
            }
          }
        }
        this.loading = getLoading()
        batchDelBillPayment(mapBillPayment, this.location).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 作废
    doCancel() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectNeedInvalidBillPaymentTip'))
        return
      }
      const list = []
      let err = false
      for (const billPayment of chooseRows) {
        if (billPayment.state <= 2 && billPayment.realClearingState === 0) {
          err = true
        }
        list.push(billPayment.uuid)
      }
      if (err) {
        this.$message.warning('勾选的数据中包含已发送资金平台或未审核通过的数据，不能作废。')
        return
      }
      this.$confirm('付款申请单作废后如需付款，需要重新创建付款单并提交审批，是否继续？', this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        batchCancelBillPaymentFunc({ 'billPaymentKeys': list }).then(res => {
          if (res.data === 'ok') {
            this.$refs.queryBillPayment.toQueryBillPaymentList()
            this.$message.success('作废成功')
          } else {
            this.$message.warning(res.data)
          }
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 重新加载列表数据
    reloadData() {
      this.$refs.queryBillPayment.toQueryBillPaymentList()
    },
    // 列表双击事件
    rowDoubleClicked(billPayment = null) {
      this.toDetail(true, billPayment)
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      console.log('toSearchTemplate', value)
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = {} // Job.queryJobLink 没有迁移过来
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    }
  }
}
</script>

<style lang="scss">
.tab-bill-payment {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 13px !important;
    }
    .el-form-item__content {
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
